import { useMemo, useState, useDeferredValue } from 'react'

import { useDebounced } from 'hooks/useDebounced'

export const useMapVisibleMarkers = (data, isLoading) => {
  const [viewportBounds, setViewportBounds] = useState(null)
  const debouncedViewportBounds = useDebounced(viewportBounds, 200)

  const visibleMarkers = useMemo(() => {
    if (isLoading && !data.length) return []
    if (!debouncedViewportBounds || !data.length) return data

    const { north, south, east, west } = debouncedViewportBounds
    const isWrapAround = west > east

    return data.filter(m => {
      const lat = m.latitude
      const lng = m.longitude
      const latOk = lat >= south && lat <= north
      const lngOk = isWrapAround ? lng >= west || lng <= east : lng >= west && lng <= east
      return latOk && lngOk
    })
  }, [data, debouncedViewportBounds, isLoading])

  const deferredMarkers = useDeferredValue(visibleMarkers)

  return {
    viewportBounds,
    setViewportBounds,
    deferredMarkers,
  }
}
